import { SxProps } from "@mui/material";
import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";

interface UseFormSelectTransmissionProps {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectTransmission: React.FC<UseFormSelectTransmissionProps> = ({
  control,
  name,
  sx = {}
}) => {
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: '', label: ''},
        {value: 'AT', label: 'AT'},
        {value: 'MT', label: 'MT'},
      ]}
      sx={{
        width: '80px',
        ...sx,
      }}
    />
  )
}